<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="650px"
  (onClose)="onCancel(ModalCloseType.CLOSE)"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div
          *transloco="let t; read: 'widgets.big-number-metadata-selector'"
          class="xi-modal__container big-number-metadata-selector__container"
        >
          <h1 class="xi-modal__title kxi-text-xlarge text-center">
            {{ t('title') }}
          </h1>

          <form
            class="xi-modal__content big-number-metadata-selector__content"
            [formGroup]="bigNumberMetadataForm"
          >
            <div class="big-number-metadata-selector__form-container">
              <div class="big-number-metadata-selector__field-one-wrapper">
                <ng-container
                  *ngTemplateOutlet="
                    tBigNumberMetadataForm;
                    context: { fieldName: 'fieldOne', fieldId: '1' }
                  "
                ></ng-container>
              </div>

              <ng-container
                *ngTemplateOutlet="
                  tBigNumberMetadataForm;
                  context: { fieldName: 'fieldTwo', fieldId: '2' }
                "
              ></ng-container>
            </div>
          </form>

          <ng-template #tBigNumberMetadataForm let-fieldName="fieldName" let-fieldId="fieldId">
            <div [formGroup]="bigNumberMetadataForm.get(fieldName)">
              <h2 class="kxi-text-medium kxi-text-600">
                {{ t('big-number-metadata-field', { fieldId }) }}
              </h2>

              <xi-dropdown
                [placeholder]="t('select-metadata-field')"
                [label]="t('metadata-field', { fieldId })"
                [data]="fieldId === '1' ? metadataDropdownOne : metadataDropdownTwo"
                [readOnly]="readOnlyField"
                select="single"
                formControlName="metadataField"
                (onValueChange)="onMetadataDropdownChange(fieldName, $event.detail.selected)"
              ></xi-dropdown>

              <xi-input-field
                formControlName="displayName"
                [label]="t('display-name', { fieldId })"
                [status]="
                  fieldId === '1' ? formStatuses.displayNameOne : formStatuses.displayNameTwo
                "
                (onChange)="onDisplayNameChange(fieldName)"
              ></xi-input-field>
              @if (!getUseFieldDisplayNameFor(fieldName).disabled) {
                <xi-checkbox
                  [label]="t('use-metadata-display-name')"
                  color="CX"
                  formControlName="useFieldDisplayName"
                  (onCheckedChange)="
                    onUseFieldDisplayNameChange(fieldName, $event.detail.isChecked)
                  "
                ></xi-checkbox>
              }
            </div>
          </ng-template>

          <div class="xi-modal__actions widget-analytic-item__actions">
            <xi-default-button
              [text]="t('cancel', { newWidget })"
              fill="text"
              (onClick)="onCancel()"
            ></xi-default-button>

            <xi-default-button
              [text]="t('save', { newWidget })"
              [disabled]="!bigNumberMetadataForm.valid"
              (onClick)="onSave()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
